import { auth } from 'api-client';

import PaltaCombo from '@palta-ui/combo';

export default {
  extends: PaltaCombo,
  props: {
    labelKey: {
      default: 'name',
    },
    country: {
      type: Object,
    },
  },
  data() {
    return {
      filterLocally: false,
      model: 'timeZones',
      api: auth,
      itemOptions: {
        itemValueKey: 'name',
      },
      filters: [
        {
          type: 'string',
          id: 'search',
          visible: false,
          condition: 'S1',
        },
        {
          type: 'belongsTo',
          id: 'country',
          visible: false,
          condition: 'BT1',
        },
      ],
    };
  },
  computed: {
    url() {
      const { country } = this;

      return `countries/${country.id}/timezones`;
    },
  },
};
